/** @format */

import React, { useRef } from "react";
import { NavLink } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { PlusOutlined } from "@ant-design/icons";

import pdf from "../../../../icons/pdf.png";
import print from "../../../../icons/print.png";
import excel from "../../../../icons/excel.png";
import { user_data } from "../../../../components/functions/usr";
import { ExcelPrint, Pdf } from "../../../../components/functions/Print";
import LoadingCard from "../../../../components/loading/loadingCard";

const REKA02_TABLE_ID = "reka02Table";
const REKA02_EXPORT_NAME = "02 reyka va uchqurgon";
const REKA02_TITLE =
  "Norin daryosi 02 reyka va Uchqo'rg'on g/u ko'rsatkichlari";
const MONTH_SHORT_NAMES = [
  "yan",
  "fev",
  "mar",
  "apr",
  "may",
  "iyun",
  "iyul",
  "avg",
  "sen",
  "okt",
  "noy",
  "dek",
];

const getMonthShortName = (month) => {
  const monthIndex = parseInt(String(month || "").slice(5, 7), 10) - 1;

  return MONTH_SHORT_NAMES[monthIndex] || "";
};

const getDayFromDate = (date) => {
  const value = String(date || "");
  const isoMatch = value.match(/^\d{4}-\d{2}-(\d{2})/);
  const dottedMatch = value.match(/^(\d{1,2})\.\d{1,2}\.\d{4}$/);
  const compactMatch = value.match(/^\d{8}$/);

  if (isoMatch) {
    return isoMatch[1];
  }

  if (dottedMatch) {
    return dottedMatch[1];
  }

  if (compactMatch) {
    return value.slice(6, 8);
  }

  return value.slice(6, 8);
};

const formatDateLabel = (month, date) => {
  const day = parseInt(getDayFromDate(date), 10);

  if (!day) {
    return "";
  }

  return `${day} ${getMonthShortName(month)}`.trim();
};

const formatEditDate = (month, date) => {
  const day = String(getDayFromDate(date)).padStart(2, "0");

  return `${month}-${day}`;
};

const getRowMonth = (month, row) => row?.__month || month;
const getRowDate = (row) => row?.__date || row?.sana;

const getNumberValue = (value) => {
  if (value === null || value === undefined || value === "" || value === "-") {
    return null;
  }

  const numberValue = parseFloat(String(value).replace(",", "."));

  return Number.isNaN(numberValue) ? null : numberValue;
};

const formatAverageValue = (value) => {
  return Math.round(value);
};

const formatTableValue = (value) => {
  return getNumberValue(value) === null ? "-" : value;
};

const calculateAverage = (values) => {
  const numbers = Array(24)
    .fill()
    .map((_, index) => getNumberValue(values?.[index + 1]))
    .filter((value) => value !== null);

  if (!numbers.length) {
    return "-";
  }

  const sum = numbers.reduce((total, value) => total + value, 0);

  return formatAverageValue(sum / numbers.length);
};

function Table5({ loading, month, data, setDate, isRange = false }) {
  const conponentPDF = useRef();

  const generatePDF = useReactToPrint({
    content: () => conponentPDF.current,
    documentTitle: "Userdata",
    onAfterPrint: () => alert("Data saved in PDF"),
  });

  return (
    <>
      <div className='table-content-top'>
        <div className='table-top-left'></div>

        <ul className='table-top-right'>
          {user_data() ? (
            user_data().region_id == 7 ? (
              <li>
                <NavLink
                  to='/reykauchqurgon/add'
                  className='btn btn-sm btn-outline-primary d-flex align-items-center'>
                  Ma'lumot kiritish&nbsp;&nbsp;&nbsp;
                  <PlusOutlined />
                </NavLink>
              </li>
            ) : null
          ) : null}

          <li>
            <button className='btn p-0' onClick={() => generatePDF()}>
              <img src={print} alt='404' />
            </button>
          </li>

          <li>
            <button onClick={() => Pdf(REKA02_TABLE_ID)} className='btn p-0'>
              <img src={pdf} alt='404' />
            </button>
          </li>

          <li>
            <button
              className='btn p-0'
              onClick={() =>
                ExcelPrint(REKA02_EXPORT_NAME, month, REKA02_TABLE_ID)
              }>
              <img src={excel} alt='404' />
            </button>
          </li>
        </ul>
      </div>

      {loading ? (
        <LoadingCard loading={loading} heightSize='80vh' />
      ) : (
        <div className='table-responsive tableFixHead'>
          <div ref={conponentPDF} style={{ width: "100%" }}>
            <table
              className='table table-bordered table-style reka02-table'
              id={REKA02_TABLE_ID} data-excel-range={isRange ? "true" : undefined}>
              <colgroup>
                <col className='reka02-date-col' />
                <col className='reka02-name-col' />
                {Array(24)
                  .fill()
                  .map((_, index) => (
                    <col className='reka02-hour-col' key={index} />
                  ))}
                <col className='reka02-average-col' />
              </colgroup>
              <thead>
                <tr className='reka02-title-row'>
                  <th colSpan={27} scope='col'>
                    {REKA02_TITLE}
                  </th>
                </tr>
                <tr>
                  <th scope='col'>Sana</th>
                  <th scope='col'>02 Reyka</th>
                  <th scope='col'>1</th>
                  <th scope='col'>2</th>
                  <th scope='col'>3</th>
                  <th scope='col'>4</th>
                  <th scope='col'>5</th>
                  <th scope='col'>6</th>
                  <th scope='col'>7</th>
                  <th scope='col'>8</th>
                  <th scope='col'>9</th>
                  <th scope='col'>10</th>
                  <th scope='col'>11</th>
                  <th scope='col'>12</th>
                  <th scope='col'>13</th>
                  <th scope='col'>14</th>
                  <th scope='col'>15</th>
                  <th scope='col'>16</th>
                  <th scope='col'>17</th>
                  <th scope='col'>18</th>
                  <th scope='col'>19</th>
                  <th scope='col'>20</th>
                  <th scope='col'>21</th>
                  <th scope='col'>22</th>
                  <th scope='col'>23</th>
                  <th scope='col'>24</th>
                  <th width={15} scope='col'>
                    O'rtacha
                  </th>
                </tr>
              </thead>

              {data.length > 0
                ? data.map((d, i) => {
                    return (
                      <tbody key={i}>
                        <tr className='reka02-main-row'>
                          <th
                            rowSpan={2}
                            style={{
                              verticalAlign: "middle",
                              textAlign: "center",
                            }}
                            className=''>
                            {user_data() ? (
                              user_data().region_id == 7 ? (
                                <NavLink
                                  to='/reykauchqurgon/add'
                                  onClick={() =>
                                    setDate?.(formatEditDate(getRowMonth(month, d), getRowDate(d)))
                                  }>
                                  {formatDateLabel(getRowMonth(month, d), getRowDate(d))}
                                </NavLink>
                              ) : (
                                <span>{formatDateLabel(getRowMonth(month, d), getRowDate(d))}</span>
                              )
                            ) : (
                              <span>{formatDateLabel(getRowMonth(month, d), getRowDate(d))}</span>
                            )}
                          </th>

                          <th>02 Reyka, sm</th>

                          {Array(24)
                            .fill()
                            .map((p, ind) => {
                              return (
                                <th className='text-center' key={ind}>
                                  {formatTableValue(d["reka"]?.[ind + 1])}
                                </th>
                              );
                            })}
                          <th
                            className='text-center'
                            style={{ fontWeight: 700 }}>
                            {calculateAverage(d["reka"])}
                          </th>
                        </tr>

                        <tr className='reka02-sub-row'>
                          <th className='fix-with'>
                            Tashlama, m<sup>3</sup>/s
                          </th>

                          {Array(24)
                            .fill()
                            .map((_, ind) => {
                              return (
                                <th className='text-center' key={ind}>
                                  {formatTableValue(d["tashlama"]?.[ind + 1])}
                                </th>
                              );
                            })}
                          <th
                            className='text-center'
                            style={{ fontWeight: 700 }}>
                            {calculateAverage(d["tashlama"])}
                          </th>
                        </tr>
                      </tbody>
                    );
                  })
                : null}
            </table>
          </div>
        </div>
      )}
    </>
  );
}

export default Table5;
